a<template>
  <div>
    <TitleBar :variant-class="'dashboard'">
      <template v-slot:title>
        <translate>Dashboard</translate>
      </template>
      <template v-slot:buttons>
        <WidgetDropdown @add-widget="addWidget" @remove-widget="removeWidget" @reset-config="resetConfig" />
      </template>
    </TitleBar>

    <div class="content dashboard">
      <div class="dashboard-grid">
        <GridContainer
          v-if="initialDataLoaded"
          ref="gridcontainer"
          :key="gridKey"
          :dashboard-items="getUserWidgets"
          @save-config="debouncedSave"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from '@/utils/'

import TitleBar from '@/components/TitleBar'
import GridContainer from '@/components/dashboard/GridContainer'
import GekkoButton from '@/components/GekkoButton'
import WidgetDropdown from '@/components/dashboard/ui/WidgetDropdown'

export default {
  name: 'Dashboard',
  components: {
    TitleBar,
    GridContainer,
    GekkoButton,
    WidgetDropdown,
  },
  data() {
    return {
      currentConfig: '',
      currentStoreConfig: '',
      initialDataLoaded: false,
      gridKey: 0,
      maxWidgets: 12,
    }
  },
  computed: {
    ...mapGetters({
      getUserWidgets: 'dashboard/getUserWidgets',
      currentCompany: 'main/getCurrentCompany',
      currentUser: 'main/getCurrentUser',
      getWidgetDefaults: 'dashboard/getWidgetDefaults',
      getCompanyId: 'main/getCompanyId',
    }),
  },
  created() {
    this.loadDashboardConfig({ company: this.currentCompany, accountants_portal: true }).then(() => {
      this.initialDataLoaded = true
    })
    this.debouncedSave = debounce((config) => {
      this.saveDashboard(config)
    }, 300)
  },
  methods: {
    ...mapActions({
      loadDashboardConfig: 'dashboard/loadDashboardConfig',
      saveDashboardConfig: 'dashboard/saveDashboardConfig',
      resetToDefault: 'dashboard/resetToDefault',
      loadUserCompanies: 'main/loadUserCompanies',
    }),
    ...mapMutations({
      setDashboardConfig: 'dashboard/SET_UPDATE_DASHBOARD_CONFIG',
      addStoreWidget: 'dashboard/ADD_WIDGET',
      deleteConfig: 'dashboard/DELETE_CONFIG',
    }),
    resetConfig() {
      this.resetToDefault()
      this.gridKey++
      this.$nextTick(() => {
        this.$refs.gridcontainer.saveCurrentDashboard('added')
      })
    },
    emptyDashboard() {
      this.deleteConfig()
      this.gridKey++
      this.$nextTick(() => {
        this.$refs.gridcontainer.saveCurrentDashboard('removed')
      })
    },
    getCurrentConfig() {
      this.currentConfig = this.$refs.gridcontainer.getDashboardCurrentConfig()
      this.currentStoreConfig = this.getUserWidgets
      console.log('Grid config ---------------------------------------')
      console.log(this.currentConfig)
      console.log('Store config --------------------------------------')
      console.log(this.currentStoreConfig)
    },
    addWidget(widget) {
      if (this.$refs.gridcontainer.getDashboardCurrentConfig().length < this.maxWidgets) {
        const widget_config = Object.assign({}, this.getWidgetDefaults(widget), {})
        this.addStoreWidget(widget_config)
      } else {
        this.$store.commit('setAlert', {
          title: this.$gettext('Too many widgets'),
          text: this.$gettext('The maximum number of widgets is ') + this.maxWidgets + '.',
          variant: 'warning',
          duration: 4,
        })
      }
    },
    removeWidget(widget) {
      this.$refs.gridcontainer.removeGridstackWidget(widget)
    },
    saveDashboard(config) {
      this.saveDashboardConfig(config)
    },
  },
}
</script>
<style lang="scss" scoped>
.content.dashboard {
  display: flex;
  padding: $gridGutter calc(1rem - #{$gridHalfGutter});
  .dashboard-grid {
    width: 100%;
  }
}

@media (max-width: '767px') {
  .content.dashboard {
    padding: $gridGutter 0;
    padding-top: 0;
  }
}
</style>

<style lang="scss">
.dashboard {
  .action-bar {
    flex-wrap: wrap;
    justify-content: flex-end;
    .btn {
      white-space: nowrap;
    }
    @media (max-width: '767px') {
      margin-top: 10px;
      .btn {
        margin-top: 10px;
      }
    }
  }
}
</style>
